import { memo } from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material'
import TableEmptyState from '../../shared/TableEmptyState'
import ReportTableContainer from './ReportTableContainer'
import TableSkeleton from './TableSkeleton'

function BaseReportTable({
  columns,
  rows,
  loading,
  limit,
  emptyMessage,
  onRowClick,
  getRowKey,
  sortBy,
  sortOrder,
  onSort,
}) {
  const showSkeleton = loading && rows.length === 0
  const colCount = columns.length

  return (
    <ReportTableContainer loading={loading} hasRows={rows.length > 0}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ bgcolor: '#f8f9fb' }}>
            {columns.map((col) => (
              <TableCell
                key={col.id}
                onClick={
                  col.sortField && onSort
                    ? () => onSort(col.sortField)
                    : undefined
                }
                sx={{
                  fontWeight: 700,
                  ...(col.sortField ? { cursor: 'pointer' } : {}),
                  ...col.headerSx,
                }}
              >
                {col.header}
                {col.sortField && sortBy === col.sortField ? ` (${sortOrder})` : ''}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {showSkeleton ? (
            <TableSkeleton rowCount={limit} colCount={colCount} />
          ) : rows.length === 0 ? (
            <TableEmptyState colSpan={colCount} message={emptyMessage} />
          ) : (
            rows.map((row) => (
              <TableRow
                key={getRowKey(row)}
                hover={Boolean(onRowClick)}
                sx={onRowClick ? { cursor: 'pointer' } : undefined}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
              >
                {columns.map((col) => (
                  <TableCell key={col.id}>
                    {col.renderCell ? col.renderCell(row) : row[col.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </ReportTableContainer>
  )
}

export default memo(BaseReportTable)
